<template>
  <div class="wp-form-modal">
    <div class="wp-form-modal__form">
      <form-builder
        v-model="value"
        :schema="schema"
        :show-submit-button="showSubmitButton"
        environment="modal"
      />
      <div class="wp-form-modal__buttons">
        <button
          class="btn btn-success"
          @click="save"
        >
          Bewaren
        </button>
        <button
          class="btn btn-danger"
          @click="$emit('cancel')"
        >
          Annuleren
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormModal',

  components: {
    formBuilder: () => import('../form-builder.vue'),
  },

  props: {
    schema: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: () => { },
    },
    showSubmitButton: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    save() {
      this.$emit('save', this.value);
    },
  },
};
</script>

<style lang="scss">
.wp-form-modal {
  background: rgba(50, 50, 50, 0.5);
  bottom: 0;
  left: 0;
  right: 0;
  position: fixed;
  top: 0;
  z-index: 999;

  &__form {
    background: white;
    border: 2px solid gray;
    border-radius: 5px;
    margin: 100px auto;
    max-height: calc(95% - 200px);
    max-width: 800px;
    overflow: scroll;
    padding: 20px;

    @media (max-height: 800px) {
      margin: 10px auto;
      max-height: calc(95% - 20px);
    }
  }

  &__buttons {
    margin: 20px 0 0 180px;
  }

  .form-builder__options {
    margin-right: 100px;
    width: -webkit-fill-available;

    input {
      width: 100%;
    }
  }

  .form-checkbox__options {
    width: -webkit-fill-available;
    margin-right: 85px;
  }

  .control-label,
  label.control-label,
  .control-group .control-label {
    width: 45%;
    margin-right: 0;
    padding-right: 0;
  }
}
</style>
